AOS.init({
  easing: 'ease-out',
  duration: 800
});